import React from 'react';
import Select from 'react-select';

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

export const SelectBoxStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: '5px 10px',
  }),
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #6A6A6A',
    height: '20px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided, state) => ({
    ...provided,
    margin: '-1px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: 0,
    color: '#555',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#6A6A6A',
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: 'none',
  }),
};

export function SelectControl() {
  return (
    <div className="common-react-select">
      <p className="field-name">
        Category<span className="asterisk">*</span>
      </p>
      <Select options={options} className="common-select" classNamePrefix="common-select" />
    </div>
  );
}
